import api from '../../../api/axios';

export const fetchWebPushConfig = () =>
  api.get('/notifications/push/config/').then((res) => res.data);

export const fetchWebPushSubscriptions = () =>
  api.get('/notifications/push/subscriptions/').then((res) => res.data);

export const enableWebPushOnServer = (body) =>
  api.post('/notifications/push/enable/', body).then((res) => res.data);

export const reconcileWebPushOnServer = (body) =>
  api.post('/notifications/push/reconcile/', body).then((res) => res.data);

export const disableWebPushOnServer = () =>
  api.post('/notifications/push/disable/', {}).then((res) => res.data);

export const revokeWebPushSubscription = (id) =>
  api.delete(`/notifications/push/subscriptions/${id}/`).then((res) => res.data);
